import { render, staticRenderFns } from "./FileList.vue?vue&type=template&id=707a0f12&scoped=true"
import script from "./FileList.vue?vue&type=script&lang=js"
export * from "./FileList.vue?vue&type=script&lang=js"
import style0 from "./FileList.vue?vue&type=style&index=0&id=707a0f12&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707a0f12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('707a0f12')) {
      api.createRecord('707a0f12', component.options)
    } else {
      api.reload('707a0f12', component.options)
    }
    module.hot.accept("./FileList.vue?vue&type=template&id=707a0f12&scoped=true", function () {
      api.rerender('707a0f12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/SAS/Components/FileList.vue"
export default component.exports